import { DiscountType as ApiDiscountType } from '@vendasta/billing';

export enum DiscountType {
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  PERCENT_AMOUNT = 'PERCENT_AMOUNT',
  FIXED_NUMBER_OF_UNITS = 'FIXED_NUMBER_OF_UNITS',
  FIXED_AMOUNT_PER_UNIT = 'FIXED_AMOUNT_PER_UNIT',
}

export function discountTypeFromApi(t: ApiDiscountType): DiscountType {
  switch (t) {
    case ApiDiscountType.DISCOUNT_TYPE_FIXED_AMOUNT_PER_UNIT:
      return DiscountType.FIXED_AMOUNT_PER_UNIT;
    case ApiDiscountType.DISCOUNT_TYPE_FIXED_NUMBER_OF_UNITS:
      return DiscountType.FIXED_NUMBER_OF_UNITS;
    case ApiDiscountType.DISCOUNT_TYPE_PERCENT_AMOUNT:
      return DiscountType.PERCENT_AMOUNT;
  }
  return DiscountType.FIXED_AMOUNT;
}

export function discountTypeToApi(t: DiscountType): ApiDiscountType {
  switch (t) {
    case DiscountType.FIXED_AMOUNT_PER_UNIT:
      return ApiDiscountType.DISCOUNT_TYPE_FIXED_AMOUNT_PER_UNIT;
    case DiscountType.FIXED_NUMBER_OF_UNITS:
      return ApiDiscountType.DISCOUNT_TYPE_FIXED_NUMBER_OF_UNITS;
    case DiscountType.PERCENT_AMOUNT:
      return ApiDiscountType.DISCOUNT_TYPE_PERCENT_AMOUNT;
  }
  return ApiDiscountType.DISCOUNT_TYPE_FIXED_AMOUNT;
}
